import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import './panel.css';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js';
import './nlp/tabler.css';

function fitText( o )
{
    o = $(o);
    if( !o.length ) return;
    var max = 3;
    while( o[0].offsetWidth < o[0].scrollWidth && max-- > 0 )
    {
        console.log( 'title', parseInt(o.css('fontSize')), o[0].offsetWidth, o[0].scrollWidth );
        o.css( {fontSize: parseInt(o.css('fontSize'))-2});
    }
}

var tab;


function exportPopup( exportId ) {
    frm.myAlert( 'Download Export', 'Exporting, please wait.', 'Cancel')
    var exportProgress = new frm.progressBar( $('.modal-body') );
    $('.modal-footer').hide();
    function check() {
        window.post('project_export_download', {exportId:exportId}, res => {
            var data = res.data;
            console.log( 'CHECK', data )
            exportProgress.set( data.progress )
            if( data.progress == 1 ) {
                setTimeout( function(){
                    frm.myAlertClose( function(){
                        $('.modal-footer').show();
                        document.location = data.url;
                    })
                }, 1000 )
            }
            else setTimeout( check, 2000 )
        })
    }
    window.close = frm.myAlertClose;
    check();
}



function ProjectExports(prop) {

    var global = window.GlobalVars;

    var projectId = global.PDFProjectId;

     useEffect( function(a){
        $('#topbuttons').html('');
        window.post( 'find_project_exports', {project:projectId}, function(res){
            console.log( 'PROJECTEXPORTS', res.data );
            var exports = res.data.records;
            var annotations = [];
            var results = $('#results').html('');
            console.log( 'exports', exports );
            if( !exports.length )
            {
                $('.alert').remove();
                var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No exports found');
                $('#topbuttons').prepend(empty);
                return;
            }
            var desc = {
                title: 'Project Exports',
                columns: {
                    exportId: 'ID',
                    items: 'Items',
                    projectName: 'project',
                    selection: 'Selection',
                    note: 'User Note',
                    createdBy: 'Created By',
                    filter: 'Filter',
                },
                filter: true,
                search: true,
                sort: true,
                initialSort: 'created',
                initialSortDir: -1,
                pageSize: 10,
                noFilter: {
                    modified:1,
                },
                noSort: null,
                centerCol: ['modified','active'],
				format: tabler.formatString,
				forceType: {
                    numProjects:1,
                    items:1,
                    created: 1,
                },
                colWidth: {
                    name: 30,
                },
                clickCol: 'exportId',
				formatCol:{
                    exportId: function(s) { return '<i class="fa fa-download"></i> ' + s},
					created: tabler.formatTimeAgoSec,
				}
                // clickCol: ['stateLabel','source'],
            }
            desc.columns.created = 'Created';
            console.log( 'DESC', desc )
            tab = tabler.table($('#documentlist'), desc, '' );
            exports.forEach( a => {
                console.log( 'addproj', a )
                tab.addRow(a, function( col, row ){
                    console.log( 'tabler clickkkkk', col, row, row[col] )
                    exportPopup( row.exportId );
                })
            });
            tab.draw();
        });
    });

    return (
        <div fluid="md p-0" className="maincontent">
            <div id="topbuttons"></div>

            <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
            </Table>
            <div id="results" className="project-browse">
            </div>
        </div>

    )
}

export default ProjectExports
